import { render, staticRenderFns } from "./showImages.vue?vue&type=template&id=143ed840&scoped=true"
import script from "./showImages.vue?vue&type=script&lang=js"
export * from "./showImages.vue?vue&type=script&lang=js"
import style0 from "./showImages.vue?vue&type=style&index=0&id=143ed840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ed840",
  null
  
)

export default component.exports